import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const getFilterList = createAsyncThunk(
    "getFilterList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/filter/filter-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const FilterSlice = createSlice({
    name: "FilterSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getFilterList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getFilterList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getFilterList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default FilterSlice.reducer;
